import { useMutation, UseMutationResult } from "react-query"
import { localConfig } from "../../../Configs/localConfig"
import { errorAlert, loadingAlert, successAlert } from "../../../utils/alert"
import { api } from "../../api"

interface PropsDeletarComando {
  cod_comando: number
  refetch_deletar: Function
}

export const useDeleteComando = (): {
carregando_deletar_comando: boolean
mudate_deletar_comando: (params: PropsDeletarComando) => void
} => {
const mutation: UseMutationResult<Response, Error, PropsDeletarComando> = useMutation(
  async (params: PropsDeletarComando) => {
    const {
      cod_comando,
     refetch_deletar
    } = params

    const config = localConfig()

    loadingAlert({ msg: 'Excluindo...', id: 'delete_comando' })

    return api
      .delete(
        `/adm/comando-app/${cod_comando}?codConta=${config.conta}`
      )
      .then((response: any) => {
        successAlert('Excluído com sucesso!', 5000, 'delete_comando')
        refetch_deletar?.()
        return response
      })
      .catch((error: Error) => {
        //@ts-ignore
        let error_response = error?.response?.data
        errorAlert(error_response?.error ?? 'Falha ao excluir fertilizante', 5000, 'delete_comando')

        throw error
      })
  }
)

return {
  carregando_deletar_comando: mutation.isLoading,
  mudate_deletar_comando: mutation.mutate,
}
}